import React from 'react';
import { Create, FormTab, TabbedForm } from 'react-admin';

import SettingsTab from './Partials/SettingsTab';
import RulesTab from './Partials/RulesTab';
import FiltersTab from './Partials/FiltersTab';
import FlightsTab from './Partials/FlightsTab';
import UserFreqCap from '../../../Common/Partials/UserFreqCap';

import AdQualityTitleName from './StaticData/TitleName';
import Title from '../../../Common/Title';
import ValidateRule from './Helpers/ValidateRule';

type Props = {
  record: any
};

const CampaignAdQualityCreate = (props: Props) => (
  <Create title={<Title title={AdQualityTitleName} record={props.record} />} {...props}>
    <TabbedForm validate={ValidateRule} redirect="edit">
      <FormTab label="Settings">
        <SettingsTab />
      </FormTab>
      <FormTab label="Rules">
        <RulesTab record={props.record} />
      </FormTab>
      <FormTab label="Filters">
        <FiltersTab record={props.record} />
      </FormTab>
      <FormTab label="Flights">
        <FlightsTab />
      </FormTab>
      <FormTab label="User Freq Caps">
        <UserFreqCap record={props.record} />
      </FormTab>
    </TabbedForm>
  </Create>
);

export default CampaignAdQualityCreate;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdQuality/Create.tsx